module.exports = __webpack_public_path__ + "static/media/volume-mute.4d9883c0.svg";